import axios from '@/api/axiosConfig'
import { ApiRoutes } from '../ApiRoutes'

export async function getLocalizedStrings() {
  const response = await axios.get(ApiRoutes.Localizer.GetLocalizedStrings)
  return response.data.result;
}
